import LegalLayout, { LegalList, Section } from "@/components/LegalLayout";
import { CONTROLLER_ADDRESS, CONTROLLER_NAME, PRIVACY_CONTACT_EMAIL } from "@/lib/legal";

export default function TermsPage() {
  return (
    <LegalLayout eyebrow="Private beta" title="Private Beta Terms" updated="22 July 2026">
      <Section title="1. Operator and scope">
        <p>
          These terms govern access to the Callsect private beta operated by {CONTROLLER_NAME}, {CONTROLLER_ADDRESS}
          ({PRIVACY_CONTACT_EMAIL}). The beta is intended for invited adult professionals and evaluation only.
        </p>
      </Section>
      <Section title="2. Your account">
        <LegalList>
          <li>Provide accurate registration information and keep your credentials confidential.</li>
          <li>Do not share an account or attempt to bypass quotas, security controls or access restrictions.</li>
          <li>You are responsible for activity performed through your account.</li>
        </LegalList>
      </Section>
      <Section title="3. Recordings and lawful use">
        <p>
          You may upload only recordings and related personal data that you are authorized to process. You
          must provide any legally required notice and obtain any legally required consent from call
          participants. Audio is processed by the transcription provider and transcript text is processed by
          the analysis provider described in the Privacy Notice. Do not upload special-category data,
          confidential material or third-party data unless you have a valid need and lawful authority to do so.
        </p>
      </Section>
      <Section title="4. Beta limits and acceptable use">
        <p>
          Usage may be subject to per-user and global limits, including call count, duration, upload size,
          generation and rate limits. Limits may change to keep the beta safe and financially sustainable.
          Do not reverse engineer, disrupt, overload, resell or use Callsect for unlawful surveillance,
          harassment or discriminatory decision-making.
        </p>
      </Section>
      <Section title="5. AI output">
        <p>
          Transcripts, summaries, findings and coaching may be incomplete or wrong. Review output before
          acting on it or transferring it to a CRM. Callsect is not legal, HR, financial or compliance advice,
          and its output must not be the sole basis for consequential decisions about a person.
        </p>
      </Section>
      <Section title="6. Availability and changes">
        <p>
          The beta is provided as available, without a service-level commitment. Features, quotas and data
          structures may change; the service may be suspended for maintenance, security or beta management.
          Free hosting may introduce a cold-start delay after inactivity.
        </p>
      </Section>
      <Section title="7. Intellectual property and feedback">
        <p>
          You retain rights in content you lawfully upload. You grant Callsect the limited rights necessary to
          process it for the requested service. You may provide feedback, which may be used to improve Callsect
          without identifying you or disclosing your confidential content.
        </p>
      </Section>
      <Section title="8. Ending participation">
        <p>
          You may stop using the beta and delete your account at any time. Callsect may restrict or end access
          for misuse, security risk or discontinuation of the beta. Data deletion is handled as described in
          the Privacy Notice.
        </p>
      </Section>
      <Section title="9. Liability and governing law">
        <p>
          To the extent permitted by law, the beta is supplied without warranties and the operator is not
          liable for indirect loss, lost revenue or decisions based on AI output. Mandatory statutory rights
          and liability that cannot lawfully be excluded remain unaffected. German law applies, subject to any
          mandatory jurisdiction or consumer protections that apply despite the professional beta scope.
        </p>
      </Section>
    </LegalLayout>
  );
}
